import {makeAutoObservable, reaction} from 'mobx';
import * as Api from '@/utils/api/api';

class CategoryStore {
    categoryList = [];
    hasSelf = false;
    currentIndex = -1;
    childCategoryList = [];

    constructor() {
        makeAutoObservable(this)
    }

    get currentCategory() {
        if (this.currentIndex < 0) {
            return null;
        } else {
            return this.categoryList[this.currentIndex];
        }
    }


    init() {
        this.childCategoryList = [];
        this.currentIndex = -1;
    }

    async fetchCategoryList() {
        let list = [];

        const {
            list: pddGoodsCategoryList,
            hasSelfCategory
        } = await Api.pddGoodsCategoryList({
            parentId: 0
        });
        list.push(...pddGoodsCategoryList);

        let selfItem = {
            id: 0,
            optName: '平台自营',
            isSelf: true,
            icon: '',
            iconActive: ''
        };

        if (hasSelfCategory) {
            selfItem.hasSelf = true;
        } else {
            selfItem.hasSelf = false;
        }
        list = [selfItem, ...list];

        this.categoryList = list;

        if (list.length > 0) {
            this.currentIndex = 0;
        }
    }

    async fetchChildCategoryList() {
        let {
            id: parentId,
            optId: parentOptId,
            optName: parentName,
            isSelf,
            hasSelf,
            icon,
            iconActive
        } = this.currentCategory;

        let childList = [];

        if (isSelf) {
            let {list} = await Api.allChildGoodsCategoryList();
            if (list.length === 0) {
                list.push({
                    id: parentId,
                    optName: parentName,
                    isSelf,
                    hasSelf
                });
            } else {
                list = list.map(item => {
                    return {
                        ...item,
                        hasSelf
                    };
                });
            }
            childList.push(...list);
        } else {
            const {list} = await Api.pddGoodsCategoryListByParentId({
                parentId,
                parentOptId,
            });
            if (list.length === 0) {
                list.push({
                    id: parentId,
                    optId: parentOptId,
                    optName: parentName,
                    isSelf
                });
            }
            childList.push(...list);
        }

        this.childCategoryList = childList;
    }
}

const store = new CategoryStore();

reaction(
    () => store.currentCategory,
    currentCategory => {
        if (!currentCategory) {
            return;
        }
        store.fetchChildCategoryList(currentCategory);
    }
);

export default store;
